import React, { Suspense, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

import Schedule from "./schedule";
import Stocks from "./goods/stocks";
import ConsumptionsSales from "./goods/consumptions-sales";
import Transfers from "./goods/transfers";
import Fuel from "./goods/fuel";
import Services from "./services";
import Occupation from "./occupation";
import Sync from "./sync";
import AutoSync from "./auto-sync";
import Home from "./home";

export const AppViews = () => {
  // TODO: Excluir este useEffect do /auto-sync
  useEffect(() => {
    // Prevent F5, Ctrl+R, Cmd+R
    const preventRefresh = (e) => {
      if (e.key === "F5" || (e.ctrlKey && e.key === "r") || (e.metaKey && e.key === "r")) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    const preventUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
      return "";
    };

    // Prevent pull-to-refresh on mobile
    let touchStartY = 0;
    const preventPullToRefresh = (e) => {
      if (e.type === "touchstart") {
        touchStartY = e.touches[0].clientY;
      } else if (e.type === "touchmove") {
        const touchY = e.touches[0].clientY;
        const touchDiff = touchY - touchStartY;

        if (touchDiff > 0 && window.scrollY === 0) {
          e.preventDefault();
        }
      }
    };

    window.addEventListener("keydown", preventRefresh);
    window.addEventListener("beforeunload", preventUnload);
    document.addEventListener("touchstart", preventPullToRefresh, { passive: false });
    document.addEventListener("touchmove", preventPullToRefresh, { passive: false });

    return () => {
      window.removeEventListener("keydown", preventRefresh);
      window.removeEventListener("beforeunload", preventUnload);
      document.removeEventListener("touchstart", preventPullToRefresh);
      document.removeEventListener("touchmove", preventPullToRefresh);
    };
  }, []);

  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route path={`${APP_PREFIX_PATH}/mobile-schedule`} component={Schedule} />
        <Route path={`${APP_PREFIX_PATH}/goods/stocks`} component={Stocks} />
        <Route path={`${APP_PREFIX_PATH}/goods/consumptions-sales`} component={ConsumptionsSales} />
        <Route path={`${APP_PREFIX_PATH}/goods/transfers`} component={Transfers} />
        <Route path={`${APP_PREFIX_PATH}/goods/fuel`} component={Fuel} />
        <Route path={`${APP_PREFIX_PATH}/services`} component={Services} />
        <Route path={`${APP_PREFIX_PATH}/occupation`} component={Occupation} />
        <Route path={`${APP_PREFIX_PATH}/sync`} component={Sync} />
        <Route path={`${APP_PREFIX_PATH}/auto-sync`} component={AutoSync} />

        <Route path={`${APP_PREFIX_PATH}/home`} component={Home} />
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/home`} />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
